<script>export var scoped = {};
scoped;</script>

<slot/>
